import Schema from 'AppReact/schema';

export default {
  value: Schema('boolean', 'primitive', { defaultValue: false }),
  label: Schema('string', 'primitive', { defaultValue: '' }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  icon: Schema({}, 'object', { defaultValue: null }),
  primary: Schema('boolean', 'primitive', { defaultValue: false })
}